// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"2916d8ba","453":"c74e7711","769":"231ea4e3","923":"005f0a51"}[chunkId] + ".chunk.js";
};